module.exports = __webpack_public_path__ + "img/17.57a8a384.png";